import { RecipeContext } from "components/recipe/providers/RecipeProvider";
import { v4 as uuidv4 } from "uuid";
import AddIngredient from "components/recipe/AddIngredient";
import BaseButton from "base/BaseButton";
import React, { useContext, useState } from "react";

const AddRecipeIngredients = ({ onRecipeUpdate }) => {
  const { ingredients } = useContext(RecipeContext);
  const [filteredIngredients, setFilteredIngredients] = useState(ingredients);
  const [recipeIngredients, setRecipeIngredients] = useState([]);
  const [ingredientsToSave, setIngredientsToSave] = useState([]);

  const addRecipeIngredient = () => {
    const newIngredient = {
      id: uuidv4(),
      name: "",
      quantity: 0,
      measurement: "",
    };
    setRecipeIngredients([...recipeIngredients, newIngredient]);
  };

  const filterIngredients = (name) => {
    //remove added ingredients from list of ingredient options
    let updatedOptions = [...ingredients];
    let ingredientNamesToSave = ingredientsToSave.map((i) => i.name);

    updatedOptions = updatedOptions?.filter(
      (i) => i.name !== name && !ingredientNamesToSave.includes(i.name),
    );
    setFilteredIngredients(updatedOptions);
  };

  const onAdd = (ingredient) => {
    //see if this is an update to an existing ingredient
    let ingredientIndex = ingredientsToSave.findIndex(
      (i) => i.id == ingredient.id,
    );
    let updatedIngredients = [...ingredientsToSave];
    if (ingredientIndex > -1) {
      updatedIngredients.splice(ingredientIndex, 1);
      updatedIngredients.push(ingredient);
    }
    onRecipeUpdate(
      "ingredients",
      ingredientIndex > -1
        ? [...updatedIngredients]
        : [...ingredientsToSave, ingredient],
    );
    setIngredientsToSave(
      ingredientIndex > -1
        ? [...updatedIngredients]
        : [...ingredientsToSave, ingredient],
    );
    filterIngredients(ingredient.name);
  };

const removeIngredient = (ingredientToRemove) => {
  // Remove the ingredient from the list used to save the recipe.
  const remainingIngredients = ingredientsToSave.filter(
    (ingredient) => ingredient.id !== ingredientToRemove.id,
  );
  // Use the latest state so we don't accidentally overwrite another update.
  setRecipeIngredients((previous) =>
    previous.filter((ingredient) => ingredient.id !== ingredientToRemove.id),
  );

  // Keep the local save list updated.
  setIngredientsToSave(remainingIngredients);

  // Update the parent recipe so saving excludes the deleted ingredient. Send an empty array if the last ingredient was deleted.
  onRecipeUpdate("ingredients", remainingIngredients);

  const selectedNames = new Set(
    remainingIngredients.map((ingredient) => ingredient.name),
  );

  // Rebuild the dropdown options from the full ingredient list.
  setFilteredIngredients(
    ingredients.filter((ingredient) => !selectedNames.has(ingredient.name)),
  );
};
  return (
    <section className="Column add-recipe-accordion-section pb-10">
      {recipeIngredients?.map((ri, index) => (
        <AddIngredient
          key={ri.id}
          ingredient={ri}
          index={index}
          ingredients={filteredIngredients}
          onAdd={(val) => onAdd(val)}
          onRemove={() => removeIngredient(ri)}
        />
      ))}
      <BaseButton
        buttonClass="mt-8"
        buttonText={
          recipeIngredients.length == 0
            ? "Add Ingredients"
            : "Add More Ingredients"
        }
        handleClick={addRecipeIngredient}
        widthClass="w-95"
      />
    </section>
  );
};

export default AddRecipeIngredients;
